export const glossaryQueryKeys = {
  glossaryJobs: {
    all: ['glossaryJobs'] as const,
    list: () => [...glossaryQueryKeys.glossaryJobs.all, 'list'] as const,
    latestStatus: () =>
      [...glossaryQueryKeys.glossaryJobs.all, 'latestStatus'] as const,
  },
}
